import { useController } from 'react-hook-form';
import { InputText, InputTextProps } from 'ui/inputs';
import { FieldProps } from './types';

type InputFieldProps = FieldProps &
  Omit<InputTextProps, 'onChange' | 'onBlur' | 'value'> & {
    valueAsNumber?: boolean;
    onBlurField?: () => void;
    transformInput?: (value: string) => string;
  };

const transformToNumber = (v: string) => (v === '' ? null : Number(v));

export const InputField = ({
  name,
  defaultValue,
  type,
  hasError = false,
  valueAsNumber,
  onBlurField,
  transformInput,
  ...rest
}: InputFieldProps) => {
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });
  const handleChange = (v: string) => {
    const transformedValue =
      transformInput && typeof transformInput === 'function' ? transformInput(v) : v;

    if (type === 'number' && valueAsNumber) {
      onChange(transformToNumber(transformedValue));
    } else {
      onChange(transformedValue);
    }
  };

  const handleBlur = () => {
    if (onBlurField) onBlurField();
    if (onBlur) onBlur();
  };

  return (
    <InputText
      {...rest}
      name={name}
      value={value}
      onBlur={handleBlur}
      onChange={handleChange}
      hasError={!!error || hasError}
      type={type}
    />
  );
};
